module.exports = __webpack_public_path__ + "img/qiu3.99b69e30.png";